<template lang='pug'>
div(:class="buttonsClass")
  div(v-if="isSingleButton")
    button.popup-button.popup-button--active(
      @click="$emit('send')"
      ) 確定
  div(v-else)
    button.popup-button(
      @click="$emit('cancel')"
      ) 取消
    //- if button is active then use .popup-button--active
    button.popup-button.popup-button--active(
      v-if="isActive"
      @click="$emit('send')"
      ) 確認
    button.popup-button.popup-button--inactive(
      v-else
      disabled) 確認
</template>

<script>
export default {
  props: {
    isScrollablePopup: Boolean,
    isSingleButton: Boolean,
    isActive: Boolean,
    isDatepicker: Boolean,

  },
  data() {
    let buttonsClass = ""
    if (this.isScrollablePopup) buttonsClass = ''
    else if (this.isDatepicker) buttonsClass = 'popup-buttons popup-buttons--normal2'
    else if (this.isSingleButton) buttonsClass = 'popup-buttons--normal'
    return {
      buttonsClass: buttonsClass
    }
  }
}
</script>